import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledHamburger = styled.svg<IconProps>`
  & .cls-1,
  .cls-2 {
    fill: none;
  }

  & .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
    stroke-width: 2px;
  }

  &.hover:hover,
  &.active {
    .cls-2 {
      stroke: var(--du-color-primary, #128370);
      stroke-width: 3px;
    }
  }
`;

const HamburgerIcon: React.FC<IconProps> = props => {
  let activeClass = props.active ? 'active' : '';
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledHamburger
      id='Hamburger-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <rect id='Margin' className='cls-1' width='32' height='32' />
      <g id='Group_17468' data-name='Group 17468' transform='translate(4 8)'>
        <line id='Line_183' data-name='Line 183' className='cls-2' x2='24' transform='translate(0 16)' />
        <line id='Line_182' data-name='Line 182' className='cls-2' x2='24' transform='translate(0 8)' />
        <line id='Line_181' data-name='Line 181' className='cls-2' x2='24' />
      </g>
    </StyledHamburger>
  );
};

export default HamburgerIcon;
